// https://developers.google.com/gtagjs/reference/ga4-events#remove_from_cart
import { trackWithGoogleAnalytics } from '../shared/trackers/trackWithGoogleAnalytics';
import { adaptItemToRequest } from './adapters/adaptItemToRequest';
import { defaultCurrencyCode } from './constants/defaultCurrency';
import { IItem } from './models/IItem';

interface IRemoveFromCartEvent {
	items: IItem[];
	currency?: string;
}

/**
 * https://developers.google.com/analytics/devguides/collection/gtagjs/enhanced-ecommerce#measure_additions_to_and_removals_from_shopping_carts
 */
export function trackRemoveFromCart({ currency, items }: IRemoveFromCartEvent) {
	trackWithGoogleAnalytics('event', 'remove_from_cart', {
		items: items.map(adaptItemToRequest),
		currency: currency ?? defaultCurrencyCode,
	});
}
